import React from 'react';

import SpinnerButton from 'src/components/SpinnerButton';

interface Props {
    spinning?: boolean;
    duplicate: () => void;
    disabled?: boolean;
}

const SaveDuplicate: React.FC<Props> = ({ spinning, duplicate, disabled }) => {
    return (
        <div className='tools-duplicate'>
            <SpinnerButton
                testid='editor-footer-duplicate'
                onClick={duplicate}
                text='Duplicate'
                disabled={disabled}
                spinning={spinning}
            />
        </div>
    );
};

export default React.memo(SaveDuplicate);
